if (!customElements.get('wavelume-owner-gallery')) {
  customElements.define('wavelume-owner-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.track = this.querySelector('.wog-track');
      this.slides = [...this.track.children];
      this.thumbs = [...this.querySelectorAll('[data-wog-index]')];
      this.dialog = this.querySelector('dialog');
      this.index = 0;
      const go = index => {
        const target = Math.max(0, Math.min(Number.isFinite(index) ? index : 0, this.slides.length - 1));
        this.track.scrollTo({left: this.slides[target].offsetLeft - this.slides[0].offsetLeft, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      };
      this.querySelector('[data-wog-prev]').addEventListener('click', () => go(this.index - 1));
      this.querySelector('[data-wog-next]').addEventListener('click', () => go(this.index + 1));
      this.thumbs.forEach(button => button.addEventListener('click', () => go(Number(button.dataset.wogIndex))));
      this.track.addEventListener('scroll', () => {
        if (!this.track.clientWidth) return;
        this.index = Math.max(0, Math.min(Math.round(this.track.scrollLeft / this.track.clientWidth), this.slides.length - 1));
        this.update();
        this.slides.forEach((slide, index) => { if (index !== this.index) slide.querySelector('video')?.pause(); });
      }, {passive:true});
      this.querySelectorAll('[data-wog-image]').forEach(button => button.addEventListener('click', () => {
        const source = button.querySelector('img'), image = this.dialog.querySelector('img');
        image.src = source.currentSrc || source.src;
        image.alt = source.alt;
        this.dialog.showModal();
      }));
      this.querySelector('[data-wog-close]').addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('click', event => { if (event.target === this.dialog) this.dialog.close(); });
      this.track.addEventListener('keydown', event => {
        if (!['ArrowLeft','ArrowRight'].includes(event.key)) return;
        event.preventDefault(); go(this.index + (event.key === 'ArrowRight' ? 1 : -1));
      });
      this.update();
    }
    update() {
      this.querySelector('.wog-status').textContent = `${this.index + 1} / ${this.slides.length}`;
      this.thumbs.forEach((button, index) => button.setAttribute('aria-current', String(index === this.index)));
      this.querySelector('[data-wog-prev]').disabled = this.index === 0;
      this.querySelector('[data-wog-next]').disabled = this.index === this.slides.length - 1;
    }
    setActiveMedia() { /* All packs share the owner-selected gallery. */ }
  });
}
